
<div class="main-container">
    <div class="close-btn-container" (click)="close()">
        <img src="../../assets/icons/close.svg" alt="Close Icon" class="close-icon">
    </div>
    <div class="soil-pin-close-container">
        <div class="header-container-new-soil-pin">
            <span><img src="../../assets/icons/soil_pin.png" alt="New Pin Icon" class="new-soil-pin-header-icon"> </span>
            <h1 mat-dialog-title  class="new-soil-pin-header">{{ 'NEW-PIN-TYPE-DIALOG.SOIL-TITLE' | translate }}</h1>
        </div>
    </div>

<div class="soil-pin-info-container">

    <div class="soil-pin-container">
        <div class="soil-pin-headers">
            <p class="soil-pin-header-text">{{'NEW-PIN-TYPE-DIALOG.DATE-TIME' | translate }}:</p>
            <p class="soil-pin-header-text">{{'NEW-PIN-TYPE-DIALOG.LATITUDE' | translate }}:</p>
            <p class="soil-pin-header-text">{{'NEW-PIN-TYPE-DIALOG.LONGITUDE' | translate }}:</p>
            <p class="soil-pin-header-text">{{'NEW-PIN-TYPE-DIALOG.FARM' | translate }}:</p>
            <p class="soil-pin-header-text">{{'NEW-PIN-TYPE-DIALOG.FIELD' | translate }}:</p>
            <p class="soil-pin-header-text">{{'NEW-PIN-TYPE-DIALOG.CREATED-BY' | translate }}:</p>
        </div>

    </div>

    <div class="soil-pin-container">
        <ng-container>
            <p class="soil-pin-info-text">{{pinObj.date ? dayjs(pinObj.date).format(dateStringFormatting) : placeholder}}</p>
            <p class="soil-pin-info-text">{{pinObj.lat}}</p>
            <p class="soil-pin-info-text">{{pinObj.lng}}</p>
            <p class="soil-pin-info-text">{{pinObj.farm}}</p>
            <p class="soil-pin-info-text">{{pinObj.field}}</p>
            <p class="soil-pin-info-text">{{pinObj.creatingUser}}</p>
        </ng-container>

    </div>
 </div>
    <div class="soil-pin-delete-btn-container">
        <button class="delete-soil-pin-btn" mat-flat-button type="button" (click)="openDeletePinDialog()">
            <div class="soil-pin-btn-content">
                <img src="../../assets/icons/delete.svg" alt="Delete Icon" class="new-soil-pin-btn-icon">
                <span><p class="soil-pin-btn-text">{{ 'NEW-PIN-TYPE-DIALOG.DELETE-PIN' | translate }}</p></span>
            </div>
        </button>
    </div>

    <mat-divider></mat-divider>

    <div class="header-container-new-soil-pin samples-header">
        <h1 mat-dialog-title  class="new-soil-pin-header">{{ 'NEW-PIN-TYPE-DIALOG.SAMPLES-TITLE' | translate }}</h1>
    </div>

    <div class="soil-sample-list-container">

        <mat-card class="soil-pin-item-card" *ngFor="let sampleItem of samples">
            <div class="soil-sample-content-container">

                <div class="soil-sample-text-container">
                    <!-- Sample, group and bag number stay on one line and wrap together once the text
                         outgrows the dialog, rather than each claiming a row of its own. -->
                    <div class="sample-name-text-container">
                        <span class="sample-inline-field">
                            <p class="soil-sample-item-bold-text">{{ 'NEW-PIN-TYPE-DIALOG.SAMPLE' | translate }}:</p>
                            <p class="soil-sample-details-text">{{sampleItem.name}}</p>
                        </span>
                        <span class="sample-inline-field sample-inline-field--sep">
                            <p class="soil-sample-item-bold-text">{{ 'NEW-PIN-TYPE-DIALOG.LINKED-GROUP' | translate }}:</p>
                            <p class="soil-sample-details-text">{{sampleItem.group.name}}</p>
                        </span>
                        <span class="sample-inline-field sample-inline-field--sep" *ngIf="sampleItem.bagNumber">
                            <p class="soil-sample-item-bold-text">{{ 'ADD-EDIT-NEW-SAMPLE-DIALOG.BAG-NUMBER' | translate }}:</p>
                            <p class="soil-sample-details-text">{{sampleItem.bagNumber}}</p>
                        </span>
                    </div>
                    <div class="sample-name-text-container">
                        <p class="soil-sample-item-bold-text" style="font-size: 10px;">{{ 'NEW-PIN-TYPE-DIALOG.CREATED-DATE' | translate }}:</p><p class="soil-sample-details-text" style="font-size: 10px;">{{sampleItem.creationDate | date: 'yyyy-MM-dd, hh:mm:ss'}}</p>
                    </div>
                </div>
                <div class="soil-sample-btn-container">

                    @if (sampleItem?.isCompleted) {
                        <mat-icon>done</mat-icon>
                    }

                    <button class="delete-soil-sample-small-btn" mat-flat-button type="button" (click)="openDeleteSampleDialog(sampleItem)">
                        <div class="soil-sample-item-content">
                            <img src="../../assets/icons/delete.svg" alt="Delete Icon" class="new-soil-pin-btn-icon">
                        </div>
                    </button>

                    <button class="edit-soil-sample-small-btn" mat-flat-button type="button" (click)="openEditSampleDialog(sampleItem)">
                        <div class="soil-sample-item-content">
                            <img src="../../assets/icons/edit.svg" alt="Edit Icon" class="new-soil-pin-btn-icon">
                        </div>
                    </button>

                    
                </div>
            </div>
        </mat-card>

    </div>

    <button class="add-sample-soil-pin-btn" mat-flat-button type="button" (click)="openAddSampleDialog()">
        <div class="soil-pin-btn-content">
            <img src="../../assets/icons/add_icon.svg" alt="Attach Icon" class="new-soil-pin-btn-icon">
            <span><p class="soil-pin-btn-text">{{ 'NEW-PIN-TYPE-DIALOG.ADD-SAMPLE' | translate }}</p></span>
        </div>
    </button>
</div>

